// extracted by mini-css-extract-plugin
export default {"returnButton":"alertLog_returnButton__IxvSX","alertTable":"alertLog_alertTable__CH67E"};